<div class="loader" [class.loader--active]="active" [class.loader--embedded]="embedded">
    <span class="loaderIcon glyphicons glyphicons-refresh"></span>
</div>